import Attachments from './Container';
export default Attachments;